import {
  BodyText,
  Card,
  Flex,
  Heading,
  Strong,
} from '@utilitywarehouse/hearth-react';
import SpotSmartMeterLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-smart-meter-light.svg';
import { useEffect, useRef } from 'react';

import { useIsInView } from '@hooks/useIsInView';

import './styles.scss';

type SmartMeterBannerProps = {
  onBannerDisplayed: () => void;
};

const SmartMeterBanner = ({ onBannerDisplayed }: SmartMeterBannerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useIsInView(ref);

  useEffect(() => {
    if (isInView) {
      onBannerDisplayed();
    }
  }, [onBannerDisplayed, isInView]);

  return (
    <Card
      direction={{ mobile: 'column-reverse', tablet: 'row' }}
      spacing="lg"
      variant="subtle"
      colorScheme="energy"
      className="energySmartMeter__Banner"
      ref={ref}
    >
      <Flex spacing="lg" direction="column">
        <Heading as="h3" size="md" className="heading">
          <Strong className="pink">Upgrade</Strong> to a smart meter for free
        </Heading>
        <BodyText>
          You'll see a link to book a <Strong>free smart meter</Strong> upgrade
          right after you sign up.
        </BodyText>
      </Flex>
      <Flex justifyContent="center">
        <img
          src={SpotSmartMeterLight}
          alt=""
          className="energySmartMeter__BannerImage"
        />
      </Flex>
    </Card>
  );
};

export { SmartMeterBanner };
